import { isArray, mergeWith } from 'lodash';

import { ICustomer } from 'shared/domain/entities';

export default function mergeCustomerResponse(
  localCustomer: ICustomer,
  responseCustomer: ICustomer,
): ICustomer {
  return mergeWith({}, localCustomer, responseCustomer, (_, srcValue) =>
    isArray(srcValue) ? srcValue : undefined,
  );
}
